/** SVG path builders in geometry coordinates (y-up handled by the view transform). */

export function circlePath(cx: number, cy: number, r: number): string {
  return `M ${cx - r} ${cy} A ${r} ${r} 0 1 0 ${cx + r} ${cy} A ${r} ${r} 0 1 0 ${cx - r} ${cy} Z`;
}

/** Ring between two circles (fill-rule="evenodd"). */
export function ringPath(cxOuter: number, rOuter: number, cxInner: number, rInner: number): string {
  return `${circlePath(cxOuter, 0, rOuter)} ${circlePath(cxInner, 0, rInner)}`;
}

/** Annular sector between radii [r0,r1] over angles [a0,a1] (radians, CCW). */
export function annularSectorPath(r0: number, r1: number, a0: number, a1: number): string {
  const large = a1 - a0 > Math.PI ? 1 : 0;
  const x0o = r1 * Math.cos(a0);
  const y0o = r1 * Math.sin(a0);
  const x1o = r1 * Math.cos(a1);
  const y1o = r1 * Math.sin(a1);
  const x0i = r0 * Math.cos(a0);
  const y0i = r0 * Math.sin(a0);
  const x1i = r0 * Math.cos(a1);
  const y1i = r0 * Math.sin(a1);
  return [
    `M ${x0o} ${y0o}`,
    `A ${r1} ${r1} 0 ${large} 1 ${x1o} ${y1o}`,
    `L ${x1i} ${y1i}`,
    `A ${r0} ${r0} 0 ${large} 0 ${x0i} ${y0i}`,
    "Z",
  ].join(" ");
}
